<template>
<!-- eslint-disable max-len -->
<span>
  <top-bar v-if="narrative.showNavbar">
    <template :slot="narrative.showMetrics ? 'challenge' : 'default'">
      <!--
        Never use v-html with end-user generated content, because it's a vector for XSS attacks
        This is what the following line used to be:
        {{ narrativeNavbarText }}
      -->
      <p v-html="narrativeNavbarText"></p>
    </template>
    <cash-navbar v-if="narrative.showMetrics" slot="cash"></cash-navbar>
    <metrics-navbar v-if="narrative.showMetrics" slot="metrics"></metrics-navbar>
  </top-bar>

<!-- <div :style="pdf ? 'display: none;' : ''"> -->
  <transition enter-active-class="animated slideInDown" leave-active-class="animated fadeOut">
    <div class="report-frame" id="report-frame">
      <div :class="pdf ? 'report pdf' : 'report'" ref="report" id="report">
        <div :class="pdf ? 'only-print pdf' : 'only-print'" style="display: flex; justify-content: space-between;">
          <h3 style="margin-top: 6px; padding: 0 30px;">NAME:</h3>
          <h3 style="margin-top: 6px; padding: 0 30px;">DATE:</h3>
        </div>
        <div :class="pdf ? 'only-print pdf' : 'only-print'" style="display: flex; justify-content: space-between; background-color: white; color: black;">
          <p style="font-size: 18pt; margin-bottom: 2.5px; padding: 10px 30px; white-space: nowrap;">{{ username }}</p>
          <p style="font-size: 18pt; margin-bottom: 2.5px; padding: 10px 30px; white-space: nowrap;">
            {{ game.carryOverMetricsFromActive && dateActiveGameCompleted != null
              ? new Date(dateActiveGameCompleted).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
              : new Date(Date.now()).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) }}
          </p>
        </div>
        <h3 style="margin-top: 6px; padding: 0 30px;">YOUR DEMONSTRATED LEADERSHIP STYLE</h3>
        <div class="report-flex">
          <div class="report-blurb">
            <h2 class="report-header">{{maxStat}}</h2>
            <p style="padding: 0 35px; font: Verdana; font-weight: normal;">The choices you made reflect {{maxStatWithArticle}} leadership style.</p>
            <p style="padding: 0 35px; text-align: justify; font: Verdana; font-weight: normal;">Leaders flex between different styles based on the situations and challenges they face. One leadership style is not always better or worse than another. Use this report to learn more about your preferred leadership style and consider why it may be your default. Take the time to explore the other styles listed in the report, and how they may or may not work with your current (or future) leadership challenges and why.</p>
          </div>
          <div class="report-blurb">
            <bar-chart :stats="stats"></bar-chart>
          </div>
        </div>
        <div v-if="!pdf" id="tabs" class="report-container no-print">
          <div class="tabs">
            <a v-on:click="activetab=1" :class="[ activetab === 1 ? 'active' : '' ]">Authentic</a>
            <a v-on:click="activetab=2" :class="[ activetab === 2 ? 'active' : '' ]">Passive</a>
            <a v-on:click="activetab=3" :class="[ activetab === 3 ? 'active' : '' ]">Transactional</a>
            <a v-on:click="activetab=4" :class="[ activetab === 4 ? 'active' : '' ]">Transformational</a>
          </div>
          <div class="content">
            <!-- vvvvvv * Transformational * vvvvvv -->
            <div v-if="activetab === 4" class="tabcontent">
              <h3 class="section-title">LEADERSHIP STYLE DEFINITION:</h3>
              <div class="section-content">
                <p>Transformational leadership is a change-oriented style of leadership used to ready followers to address both challenges and opportunities. Leaders who demonstrate transformational leadership behaviors seek to understand followers’ needs and capabilities and then support their followers in learning how to develop to address the goals and objectives that are important to their team and organization. Transformational leaders work to develop and transform their followers into becoming leaders themselves. Transformational leadership behaviors inspire followers to align with their vision and mission to be successful. Transformational leaders motivate higher levels of follower performance, satisfaction, and commitment to their team and the organization, especially when change is required.  Transformational leaders motivate their followers to question the way they think about challenges and opportunities to come up with the best solutions. They also serve as a role model for others, helping them to fully understand the core values that drive the work they do to achieving the highest standards.</p>
                <p>Four distinct categories of behavior are associated with Transformational Leadership:</p>
                <ul>
                  <li>Individualized Consideration: Understand the needs and motivation of each individual and then help them to develop a plan to achieve their full potential.</li>
                  <li>Intellectual Stimulation: Leveraging the best thinking of your followers by encouraging them to challenge their assumptions, ideas and ways of working to improve their performance and the performance of your team and organization.</li>
                  <li>Inspirational Motivation: Help followers to see a positive vision of the future and how they can play a significant role in shaping that future. Raising their optimism about what they can accomplish by working together.</li>
                  <li>Idealized Influence:  Setting a high standard for doing what’s right and being a role model of those standards that followers come to respect and display with others.</li>
                </ul>
              </div>
              <h3 class="section-title">STRENGTHS:</h3>
              <div class="section-content">
                <p>A transformational leader:</p>
                <ul>
                  <li>Understands the needs and capabilities of others to optimize their development.</li>
                  <li>Enhances innovation and creativity to come up with solutions that have not been considered.</li>
                  <li>Inspires others to achieve their full potential and to aspire each day to meet and exceed expectations.</li>
                  <li>Creates in others the standards of conduct and high expectations that become a role model for others to aspire to in their work and careers.</li>
                </ul>
              </div>
              <h3 class="section-title">CHALLENGES:</h3>
              <div class="section-content">
                <p>This style of leadership takes time to develop in both the leader and those led. Transformational leadership then builds on the other styles of leadership to sustain the highest levels of motivation and performance.</p>
              </div>
              <h3 class="section-title">WHEN SHOULD YOU USE THIS STYLE?</h3>
              <div class="section-content">
                <p>Whenever there is a need to develop others, to address challenges and opportunities facing them, where the higher to highest levels of motivation are required. Such leaders leverage the full potential of those led.</p>
              </div>
              <h3 class="section-title">WHEN SHOULD YOU EXPLORE OTHER STYLES?</h3>
              <div class="section-content">
                <p>When the tasks and situation are very routine, well understood and sufficient time is available to get them done, other more transactional styles are sufficient in the short-term.</p>
              </div>
              <h3 class="section-title">ADDITIONAL SOURCES:</h3>
              <div class="section-content">
                <p>
                  Avolio, B.J. (2011). Full range leadership development (2nd edition).  Thousand Oaks, CA: SAGE.
                  <br/>
                  <a href="https://www.cio.com/article/3257184/what-is-transformational-leadership-a-model-for-motivating-innovation.html" target="_blank">https://www.cio.com/article/3257184/what-is-transformational-leadership-a-model-for-motivating-innovation.html</a>
                </p>
              </div>
            </div>
            <!-- vvvvvv * Transactional * vvvvvv -->
            <div v-if="activetab === 3" class="tabcontent">
              <h3 class="section-title">LEADERSHIP STYLE DEFINITION:</h3>
              <div class="section-content">
                <p>Transactional leadership is often focused on individuals and groups achieving expected levels of performance. Transactional leader behaviors clarify goals and expectations, provide resources needed to get the task done, and offer recognition for completing what is required. When Transactional leadership is done, well recognition is offered when goals are achieved. This is a key ingredient to building trust with your team. A transactional leader who always meets people’s expectations, is seen as being reliable and over time, trustworthy.</p>
              </div>
              <h3 class="section-title">STRENGTHS:</h3>
              <div class="section-content">
                <p>This style helps get the work done each and every day. Leaders who exhibit this style focus on:</p>
                <ul>
                  <li>Optimizing the reliability of how processes work, and how people proceed to deliver on their expectations, this is a central characteristic of this leadership style.</li>
                  <li>Transactional leadership is foundational to getting people to set goals, commit to them, and complete them, achieving expected performance.</li>
                </ul>
              </div>
              <h3 class="section-title">CHALLENGES:</h3>
              <div class="section-content">
                <p>A transactional leadership approach will fall short on providing a focus on long term development of others, and in addressing significant individual and organizational change/innovation since its focus is not on either, but rather getting things done when everything is as expected or typical day in and day out performance.</p>
              </div>
              <h3 class="section-title">WHEN SHOULD YOU USE THIS STYLE?</h3>
              <div class="section-content">
                <p>Transactional leader behaviors may be sufficient for achieving straightforward objectives—those objectives that are the result of achieving expected performance given the goals set by the leader. Transactional leadership is essential for developing a repeatable, reliable practice that consistently achieves goals and objectives that have been set.</p>
              </div>
              <h3 class="section-title">WHEN SHOULD YOU EXPLORE OTHER STYLES?</h3>
              <div class="section-content">
                <p>Transactional leadership is the basis for effective leadership. Oftentimes, leaders must motivate their followers to perform beyond routine expectations to compete in a fast-changing world, and in those situations the leader has to explore other styles such as transformational to remain competitive. Leaders in an organization may not be trusted, which requires first building an authentic leadership foundation.</p>
              </div>
              <h3 class="section-title">ADDITIONAL SOURCES:</h3>
              <div class="section-content">
                <p>
                  Avolio, B.J. (2011). Full range leadership development (2nd edition).  Thousand Oaks, CA: SAGE.
                  <br/>
                  <a href="https://en.wikipedia.org/wiki/Transactional_leadership" target="_blank">https://en.wikipedia.org/wiki/Transactional_leadership</a>
                  <br/>
                  <a href="https://www.cio.com/article/3257184/what-is-transformational-leadership-a-model-for-motivating-innovation.html" target="_blank">https://www.cio.com/article/3257184/what-is-transformational-leadership-a-model-for-motivating-innovation.html</a>
                </p>
              </div>
            </div>
            <!-- vvvvvv * Passive * vvvvvv -->
            <div v-if="activetab === 2" class="tabcontent">
              <h3 class="section-title">LEADERSHIP STYLE DEFINITION:</h3>
              <div class="section-content">
                <p>Passive leadership behavior is characterized by a ‘wait and see’ orientation. Passive leaders avoid specifying agreements, clarifying expectations, and providing goals and standards for others. They focus on disciplinary actions after mistakes have been made and are more likely to ignore them to criticize or praise. Such leaders only intervene to take corrective action when something happens that needs addressing. For example, they will fix a visible issue, but won’t necessarily fix underlying causes or related issues.</p>
                <p>Keep in mind what we said above, one leadership style is not always better or worse than another. The passive leadership style can be used when you want to empower others. This approach can be intentionally used to delegate to others, allowing them to initiate goals and complete work. You should also ask yourself, are they ready for that delegation or empowerment?</p>
              </div>
              <h3 class="section-title">STRENGTHS:</h3>
              <div class="section-content">
                <p>When used intentionally the passive leadership style can:</p>
                <ul>
                  <li>Empower followers to act and give them more room in their lanes of work to decide what they will do or not do in terms of their performance.</li>
                </ul>
              </div>
              <h3 class="section-title">CHALLENGES:</h3>
              <div class="section-content">
                <p>This is not the right style for followers who need direction and help in setting goals. It is also not ideal when you need expertise in developing team members to do the work. This style will not work well when you must make changes on a regular basis to adapt to the changes in in your team’s work context with consumers and with technology as well as any changes impacting one’s organization. This style is not effective where work processes must continuously monitor the work that is being done to make sure it is being done efficiently, effective and safely.</p>
              </div>
              <h3 class="section-title">WHEN SHOULD YOU USE THIS STYLE?</h3>
              <div class="section-content">
                <p>When followers know what they are doing and need little guidance from their leaders. When followers are ready to assume control of their own work.</p>
              </div>
              <h3 class="section-title">WHEN SHOULD YOU EXPLORE OTHER STYLES?</h3>
              <div class="section-content">
                <p>Any time there is a great deal of complexity associated with the work people are doing, change is required regularly, innovation is needed, safety is paramount and coordination across individuals and groups is essential and those individuals and groups vary in their capabilities, motivation and needs.</p>
              </div>
              <h3 class="section-title">ADDITIONAL SOURCES:</h3>
              <div class="section-content">
                <p>
                  Avolio, B.J. (2011). Full range leadership development (2nd edition).  Thousand Oaks, CA: SAGE.
                  <br/>
                  <a href="https://en.wikipedia.org/wiki/Full_Range_Leadership_Model" target="_blank">https://en.wikipedia.org/wiki/Full_Range_Leadership_Model</a>
                  <br/>
                  Bass, ed. by Bruce J. Avolio & Bernard M. (2002). Developing potential across a full range of leaderships : cases on transactional and transformational leadership. Mahwah, NJ [u.a.]: Lawrence Erlbaum Associates. ISBN 978-0805838947.
                </p>
              </div>
            </div>
            <!-- vvvvvv * Authentic * vvvvvv -->
            <div v-if="activetab === 1" class="tabcontent">
              <h3 class="section-title">LEADERSHIP STYLE DEFINITION:</h3>
              <div class="section-content">
                <p>Authentic Leadership is leading from the “theory of one’s self” and is tied to your high moral values and beliefs. The core of Authentic Leadership is doing what is good for others, while being guided by one’s conscience, even if it requires personal sacrifice. Leaders who demonstrate Authentic Leadership behaviors have a strong understanding of who they are and seek to interact with others across a broad range of situations representing to them their authenticity. In addition to maintaining stakeholder trust, an authentic approach to leadership results in a positive impact on follower self-confidence, emotional well-being, motivation and performance.</p>
              </div>
              <h3 class="section-title">STRENGTHS:</h3>
              <div class="section-content">
                <p>Leaders who exhibit this style are often:</p>
                <ul>
                  <li>Self-aware of how they impact others.</li>
                  <li>Able to adapt their approach to help optimize the development and performance of others.</li>
                  <li>Convey their high in moral and ethical standards.</li>
                  <li>Can build goodwill, trust and commitment.</li>
                  <li>Successfully motivate others to follow them.</li>
                  <li>Balanced, just and fair. They create a climate and culture where the people they lead feel safe to voice their opinions, and to challenge each other, including the leader to come up with the best solutions.</li>
                  <li>Transparent, they value and reinforce open lines of communication and the exchange of all information.</li>
                </ul>
              </div>
              <h3 class="section-title">CHALLENGES:</h3>
              <div class="section-content">
                <p>Authentic leadership is the foundation for all positive styles of leadership. With this foundation, leaders can create clear expectations, clarify the goal and get the work done more effectively since followers would be less likely to question their intentions.</p>
              </div>
              <h3 class="section-title">WHEN SHOULD YOU USE THIS STYLE?</h3>
              <div class="section-content">
                <p>When people doubt what leaders have told them in the past, when they are not trusted, when people are conflicted over what the right thing is to do, when there has been a lack of transparency and where leaders in the past were not seen as fair. If the authentic leader doesn’t build the foundation for authenticity, they will spend a lot of time and resources and will not get very far in their efforts to lead others.</p>
              </div>
              <h3 class="section-title">WHEN SHOULD YOU EXPLORE OTHER STYLES?</h3>
              <div class="section-content">
                <p>You should always explore other styles that you can use to build on the foundation of authentic leadership. For example, if in the eyes of your followers you are that leader, you can challenge them to innovate, to invest in their development, to strive to achieve an audacious and challenging mission, and to communicate a need for significant change.  The authentic foundation builds trust and goodwill so they will listen and find a way to address those challenges.</p>
              </div>
              <h3 class="section-title">ADDITIONAL SOURCES:</h3>
              <div class="section-content">
                <p>
                  Avolio, B.J. & Hannah, S.T. (2019, Online September). An enduring leadership myth. Organizational Dynamics.
                  <br/>
                  Avolio, B.J. (2016).  Candor and transparency: Aligning your leadership constellation. People & Strategy, 39 (4), 17-20.
                  <br/>
                  Avolio, B.J., & Luthans, F.  (2006). High impact leader: Moments matter in authentic leadership development.  NY:  McGraw-Hill.
                  <br/>
                  Avolio, B.J. (2005).  Leadership development in balance:  Made/Born.  NJ:  Erlbaum & Associates.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div :class="pdf ? 'only-print pdf' : 'only-print'" style="margin-top: -25px;">
          <div class="stat-section">
            <div class="max-stat-marker" :style="(maxStatIsAuthentic) ? '' : 'visibility: hidden !important;'"/>
            <div class="stat-info-section">
              <h3 class="stat-info-title">AUTHENTIC</h3>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">LEADERSHIP STYLE DEFINITION: </span> Authentic Leadership is leading from the “theory of one’s self” and is tied to your high moral values and beliefs. The core of Authentic Leadership is doing what is good for others, while being guided by one’s conscience, even if it requires personal sacrifice. Leaders who demonstrate Authentic Leadership behaviors have a strong understanding of who they are and seek to interact with others across a broad range of situations representing to them their authenticity. In addition to maintaining stakeholder trust, an authentic approach to leadership results in a positive impact on follower self-confidence, emotional well-being, motivation and performance.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">STRENGTHS: </span> Leaders who exhibit this style are often:
                - Self-aware of how they impact others.
                - Able to adapt their approach to help optimize the development and performance of others.
                - Convey their high in moral and ethical standards.
                - Can build goodwill, trust and commitment.
                - Successfully motivate others to follow them.
                - Balanced, just and fair. They create a climate and culture where the people they lead feel safe to voice their opinions, and to challenge each other, including the leader to come up with the best solutions.
                - Transparent, they value and reinforce open lines of communication and the exchange of all information.
              </p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">CHALLENGES: </span> Authentic leadership is the foundation for all positive styles of leadership. With this foundation, leaders can create clear expectations, clarify the goal and get the work done more effectively since followers would be less likely to question their intentions.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">WHEN SHOULD YOU USE THIS STYLE?: </span> When people doubt what leaders have told them in the past, when they are not trusted, when people are conflicted over what the right thing is to do, when there has been a lack of transparency and where leaders in the past were not seen as fair. If the authentic leader doesn’t build the foundation for authenticity, they will spend a lot of time and resources and will not get very far in their efforts to lead others.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">WHEN SHOULD YOU EXPLORE OTHER STYLES?: </span> You should always explore other styles that you can use to build on the foundation of authentic leadership. For example, if in the eyes of your followers you are that leader, you can challenge them to innovate, to invest in their development, to strive to achieve an audacious and challenging mission, and to communicate a need for significant change.  The authentic foundation builds trust and goodwill so they will listen and find a way to address those challenges.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">ADDITIONAL SOURCES: </span>
                Avolio, B.J. & Hannah, S.T. (2019, Online September). An enduring leadership myth. Organizational Dynamics.
                <br/>
                Avolio, B.J. (2016).  Candor and transparency: Aligning your leadership constellation. People & Strategy, 39 (4), 17-20.
                <br/>
                Avolio, B.J., & Luthans, F.  (2006). High impact leader: Moments matter in authentic leadership development.  NY:  McGraw-Hill.
                <br/>
                Avolio, B.J. (2005).  Leadership development in balance:  Made/Born.  NJ:  Erlbaum & Associates.
              </p>
            </div>
          </div>
          <div class="stat-section">
            <div class="max-stat-marker" :style="(maxStatIsPassive) ? '' : 'visibility: hidden !important;'"/>
            <div class="stat-info-section">
              <h3 class="stat-info-title">PASSIVE</h3>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">LEADERSHIP STYLE DEFINITION: </span> Passive leadership behavior is characterized by a ‘wait and see’ orientation. Passive leaders avoid specifying agreements, clarifying expectations, and providing goals and standards for others. They focus on disciplinary actions after mistakes have been made and are more likely to ignore them to criticize or praise. Such leaders only intervene to take corrective action when something happens that needs addressing.   For example, they will fix a visible issue, but won’t necessarily fix underlying causes or related issues. Keep in mind what we said above, one leadership style is not always better or worse than another. The passive leadership style can be used when you want to empower others. This approach can be intentionally used to delegate to others, allowing them to initiate goals and complete work.  You should also ask yourself, are they ready for that delegation or empowerment?</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">STRENGTHS: </span> When used intentionally the passive leadership style can empower followers to act and give them more room in their lanes of work to decide what they will do or not do in terms of their performance.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">CHALLENGES: </span> This is not the right style for followers who need direction and help in setting goals. It is also not ideal when you need expertise in developing team members to do the work. This style will not work well when you must make changes on a regular basis to adapt to the changes in in your team’s work context with consumers and with technology as well as any changes impacting one’s organization. This style is not effective where work processes must continuously monitor the work that is being done to make sure it is being done efficiently, effective and safely.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">WHEN SHOULD YOU USE THIS STYLE?: </span> When followers know what they are doing and need little guidance from their leaders. When followers are ready to assume control of their own work.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">WHEN SHOULD YOU EXPLORE OTHER STYLES?: </span> Any time there is a great deal of complexity associated with the work people are doing, change is required regularly, innovation is needed, safety is paramount and coordination across individuals and groups is essential and those individuals and groups vary in their capabilities, motivation and needs.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">ADDITIONAL SOURCES: </span>
                Avolio, B.J. (2011). Full range leadership development (2nd edition).  Thousand Oaks, CA: SAGE.
                <br/>
                <a href="https://en.wikipedia.org/wiki/Full_Range_Leadership_Model" target="_blank">https://en.wikipedia.org/wiki/Full_Range_Leadership_Model</a>
                <br/>
                Bass, ed. by Bruce J. Avolio & Bernard M. (2002). Developing potential across a full range of leaderships : cases on transactional and transformational leadership. Mahwah, NJ [u.a.]: Lawrence Erlbaum Associates. ISBN 978-0805838947.
              </p>
            </div>
          </div>
          <div class="stat-section">
            <div class="max-stat-marker" :style="(maxStatIsTransactional) ? '' : 'visibility: hidden !important;'"/>
            <div class="stat-info-section">
              <h3 class="stat-info-title">TRANSACTIONAL</h3>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">LEADERSHIP STYLE DEFINITION: </span>Transactional leadership is often focused on individuals and groups achieving expected levels of performance. Transactional leader behaviors clarify goals and expectations, provide resources needed to get the task done, and offer recognition for completing what is required. When Transactional leadership is done, well recognition is offered when goals are achieved. This is a key ingredient to building trust with your team. A transactional leader who always meets people’s expectations, is seen as being reliable and over time, trustworthy.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">STRENGTHS: </span> This style helps get the work done each and every day. Leaders who exhibit this style focus on: - Optimizing the reliability of how processes work, and how people proceed to deliver on their expectations, this is a central characteristic of this leadership style. - Transactional leadership is foundational to getting people to set goals, commit to them, and complete them, achieving expected performance.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">CHALLENGES: </span> A transactional leadership approach will fall short on providing a focus on long term development of others, and in addressing significant individual and organizational change/innovation since its focus is not on either, but rather getting things done when everything is as expected or typical day in and day out performance.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">WHEN SHOULD YOU USE THIS STYLE?: </span> Transactional leader behaviors may be sufficient for achieving straightforward objectives—those objectives that are the result of achieving expected performance given the goals set by the leader.  Transactional leadership is essential for developing a repeatable, reliable practice that consistently achieves goals and objectives that have been set.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">WHEN SHOULD YOU EXPLORE OTHER STYLES?: </span> Transactional leadership is the basis for effective leadership. Oftentimes, leaders must motivate their followers to perform beyond routine expectations to compete in a fast-changing world, and in those situations the leader has to explore other styles such as transformational to remain competitive. Leaders in an organization may not be trusted, which requires first building an authentic leadership foundation.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">ADDITIONAL SOURCES: </span>
                Avolio, B.J. (2011). Full range leadership development (2nd edition).  Thousand Oaks, CA: SAGE.
                <br/>
                <a href="https://en.wikipedia.org/wiki/Transactional_leadership" target="_blank">https://en.wikipedia.org/wiki/Transactional_leadership</a>
                <br/>
                <a href="https://www.cio.com/article/3257184/what-is-transformational-leadership-a-model-for-motivating-innovation.html" target="_blank">https://www.cio.com/article/3257184/what-is-transformational-leadership-a-model-for-motivating-innovation.html</a>
              </p>
            </div>
          </div>
          <div class="stat-section">
            <div class="max-stat-marker" :style="(maxStatIsTransformational) ? '' : 'visibility: hidden !important;'"/>
            <div class="stat-info-section">
              <h3 class="stat-info-title">TRANSFORMATIONAL</h3>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">LEADERSHIP STYLE DEFINITION: </span>Transformational leadership is a change-oriented style of leadership used to ready followers to address both challenges and opportunities. Leaders who demonstrate transformational leadership behaviors seek to understand followers’ needs and capabilities and then support their followers in learning how to develop to address the goals and objectives that are important to their team and organization. Transformational leaders work to develop and transform their followers into becoming leaders themselves. Transformational leadership behaviors inspire followers to align with their vision and mission to be successful. Transformational leaders motivate higher levels of follower performance, satisfaction, and commitment to their team and the organization, especially when change is required.  Transformational leaders motivate their followers to question the way they think about challenges and opportunities to come up with the best solutions. They also serve as a role model for others, helping them to fully understand the core values that drive the work they do to achieving the highest standards.
                Four distinct categories of behavior are associated with Transformational Leadership:
                - Individualized Consideration: Understand the needs and motivation of each individual and then help them to develop a plan to achieve their full potential.
                - Intellectual Stimulation: Leveraging the best thinking of your followers by encouraging them to challenge their assumptions, ideas and ways of working to improve their performance and the performance of your team and organization.
                - Inspirational Motivation: Help followers to see a positive vision of the future and how they can play a significant role in shaping that future. Raising their optimism about what they can accomplish by working together.
                - Idealized Influence:  Setting a high standard for doing what’s right and being a role model of those standards that followers come to respect and display with others.
              </p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">STRENGTHS: </span>
                A transformational leader:
                - Understands the needs and capabilities of others to optimize their development.
                - Enhances innovation and creativity to come up with solutions that have not been considered.
                - Inspires others to achieve their full potential and to aspire each day to meet and exceed expectations.
                - Creates in others the standards of conduct and high expectations that become a role model for others to aspire to in their work and careers.
              </p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">CHALLENGES: </span> This style of leadership takes time to develop in both the leader and those led. Transformational leadership then builds on the other styles of leadership to sustain the highest levels of motivation and performance.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">WHEN SHOULD YOU USE THIS STYLE?: </span> Whenever there is a need to develop others, to address challenges and opportunities facing them, where the higher to highest levels of motivation are required. Such leaders leverage the full potential of those led.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">WHEN SHOULD YOU EXPLORE OTHER STYLES?: </span> When the tasks and situation are very routine, well understood and sufficient time is available to get them done, other more transactional styles are sufficient in the short-term.</p>
              <p class="stat-info-subsection"><span class="stat-info-subsection-title">ADDITIONAL SOURCES: </span>
                Avolio, B.J. (2011). Full range leadership development (2nd edition).  Thousand Oaks, CA: SAGE.
                <br/>
                <a href="https://www.cio.com/article/3257184/what-is-transformational-leadership-a-model-for-motivating-innovation.html" target="_blank">https://www.cio.com/article/3257184/what-is-transformational-leadership-a-model-for-motivating-innovation.html</a>
              </p>
            </div>
          </div>
        </div>
        <!-- footer -->
        <div
          v-if="pdf && (activeEnvironment.reportFooter || activeEnvironment.reportFooterLogo)"
          style="
            background-color: black;
            color: white;
            padding: 4px 50px;
            width: 100%;
            min-height: 36px;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: flex-start;
          "
        >
          <!-- footer message (e.g. displaying ©) -->
          <div v-html="activeEnvironment.reportFooter"></div>
          <!-- footer logo -->
          <img
            v-if="activeEnvironment.reportFooterLogo"
            :src="resolveAssetPath(activeEnvironment.reportFooterLogo, 'ui/customer')"
            :class="`footer-logo ${pdf ? 'pdf' : ''}`"
            ref="footerLogo"
          >
        </div>
      </div>
    </div>
  </transition>
<!-- </div> -->

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <div v-if="pdf" class="download-message">Downloading!</div>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <button v-if="showNarratorNotification"
      class="btn download-button"
      @click.prevent="onClickDownload"
    >Download</button>
  </transition>

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <bottom-bar :next="showNarratorNotification ? onComplete : undefined" :tabindex="3" ref="bottomBar" :noBar="true">
      <span slot="button">
        <span v-html="(narrative && narrative.nextButtonText) ? narrative.nextButtonText : ((game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next')"></span>
      </span>
    </bottom-bar>
  </transition>
</span>
</template>

<script>
/* eslint-disable max-len */
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import JsPDF from 'jspdf';
import domtoimage from 'dom-to-image-more';

import TopBar from '../ui/TopBar';
import MetricsNavbar from '../ui/MetricsNavbar';
import CashNavbar from '../ui/CashNavbar';
import Narrator from '../ui/Narrator';
import NarratorNotification from '../ui/NarratorNotification';
import BottomBar from '../ui/BottomBar';
import BarChart from '../ui/BarChart';

export default {
  // $emit 'input' on complete
  components: {
    TopBar,
    MetricsNavbar,
    CashNavbar,
    Narrator,
    NarratorNotification,
    BottomBar,
    BarChart
  },
  data() {
    return {
      activetab: 1,
      showNarrator: false,
      showNarratorNotification: false,
      stats: [
        {
          name: 'Transformational',
          value: 0,
        },
        {
          name: 'Transactional',
          value: 0,
        },
        {
          name: 'Passive',
          value: 0,
        },
        {
          name: 'Authentic',
          value: 0,
        }
      ],
      pdf: false
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'characters',
      'tooltip',
      'narrative',
      'lastNarrative',
      'nextNarrative',
      'narrativeNavbarText',
      'narrativeText',
      'group',
      'me',
      'game',
      'dateActiveGameCompleted'
    ]),
    username() {
      const {
        firstName = '',
        lastName = '',
        email = ''
      } = this.me || {};
      return firstName || lastName ? `${firstName} ${lastName}` : email;
    },
    maxStat() {
      let maxStat = { name: '', value: -1 };
      for (let i = 0; i < this.stats.length; ++i) {
        if (this.stats[i].value > maxStat.value) {
          maxStat = this.stats[i];
        }
      }
      return maxStat.name;
    },
    maxStatWithArticle() {
      if (this.maxStat.startsWith('A')
        || this.maxStat.startsWith('E')
        || this.maxStat.startsWith('I')
        || this.maxStat.startsWith('O')
        || this.maxStat.startsWith('U')) {
        return `an ${this.maxStat}`;
      }
      return `a ${this.maxStat}`;
    },
    maxStatIsAuthentic() {
      return this.maxStat === 'Authentic';
    },
    maxStatIsPassive() {
      return this.maxStat === 'Passive';
    },
    maxStatIsTransactional() {
      return this.maxStat === 'Transactional';
    },
    maxStatIsTransformational() {
      return this.maxStat === 'Transformational';
    }
  },
  // async created() {
  //   await this.loadPageData();
  //   this.setStats();
  // },
  methods: {
    ...mapActions([
      'stopSounds',
      'getMyGroup'
    ]),
    async show() {
      this.showNarrator = true;
      await Vue.nextTick();
      this.stopSounds();
      await new Promise(resolve => setTimeout(resolve, 1250));
      this.showNarratorNotification = true;
      await new Promise(resolve => setTimeout(resolve, 1250));
      await Vue.nextTick();
    },
    async reset() {
      await Vue.nextTick();
      await this.show();
    },
    navigate() {
      this.$refs.bottomBar.navigate();
    },
    async onComplete() {
      if (this.tooltip && this.tooltip.preventStateProgressionWhileOpen) {
        window.dispatchEvent(new Event('click'));
        return;
      }
      this.$emit('input');
    },
    async loadPageData() {
      try {
        const { _id: groupId } = this.group;
        await this.getMyGroup({ groupId });
      } catch (err) {
        if (await this.$router.handleGameError(err)) return;
        this.$router.showGameErrorCritical();
      }
    },
    statName(i) {
      if (i === 0) return 'Authentic';
      if (i === 1) return 'Passive';
      if (i === 2) return 'Transactional';
      if (i === 3) return 'Transformational';
      return 'Authentic';
    },
    setStats() {
      const mLength = this.group.players[0].metrics.length;
      let maxStat = 0;
      let activeStat = 1;

      this.stats = this.group.players[0].metrics;

      for (let i = 0; i < mLength; i++) {
        this.stats[i].name = this.statName(i);
        if (this.stats[i].value > maxStat) {
          maxStat = this.stats[i].value;
          activeStat = i + 1;
        }
      }

      this.activetab = activeStat;
    },
    async onClickDownload() {
      if (this.pdf) return;
      // PDF download works in all browsers except pre-chromium Edge
      // (fails at domtoimage.toPng, and no replacement seems viable, see above)
      // fix for Edge (for now): make the page printable, and open the print dialog automatically
      // (in response to domtoimage.toPng or any other part of the autodownload throwing any error)
      // The user can print to PDF or actually print. Bonus is you can print in other browsers too.
      // Edge requires the user to manually set the Scale in the print dialog to 50% for it to fit.
      // Note that this is generally no longer a problem with the new chromium-based Edge.

      this.pdf = true;
      await Vue.nextTick();
      await new Promise((resolve, reject) => {
        if (this.$refs.footerLogo && this.$refs.footerLogo.complete) { // wait for logo to load
          resolve();
        } else if (this.$refs.footerLogo) {
          this.$refs.footerLogo.addEventListener('load', resolve);
          this.$refs.footerLogo.addEventListener('error', reject);
        } else {
          console.log('No footerLogo ref found');
          resolve();
        }
      });
      await domtoimage.toPng(this.$refs.report, { cacheBust: true })
        .then((dataUrl) => {
          this.pdf = false;
          const doc = new JsPDF('p', 'pt', 'a4');
          doc.addImage(dataUrl, 'PNG', 45, 44.4, 500, 757);

          // TODO: if no autodownload, no soft-lock (explained below), so soft-lock fix commented out
          doc.save('Leadership Report.pdf');
          // Before we download the PDF, we have to consider the possibility that the
          // user's settings are set to view the PDF in the browser first when downloading a PDF
          // (instead of actually downloading it). This can be true in many modern browsers.
          // This is a problem because if it opens in the same page, it destroys the Vue app state.
          // This ends up soft-locking the player such that they can't get past the report page.
          // This problem came to my attention when a Firefox update changed the PDF download behavior
          // to default to viewing it in browser (on the same page) when you initiate a download.
          // To fix this while minimally impacting anyone whose browser actually just downloads stuff
          // when a download is initiated, instead first open a new tab, then artificially initiate
          // the download with a bogus DOM hyperlink element that targets the bloburl output by JsPDF,
          // which either downloads the file or loads the blob viewer. If it doesn't load the
          // blob viewer, we autoclose the tab, leaving you back on the report page. If it does load
          // the blob viewer, the user is left in the blob viewer, where they can either:
          // - close it, returning to the original report tab without downloading, where they can
          //   hit print or refresh to save off the report another way, or continue on with the game.
          // - download/print it (which presents a system dialog, and does carry over the expected
          //   default name) (and then close it to return back to the game).
          // const win = window.open(`${window.location.origin}/downloadplayerreport/${encodeURIComponent('Leadership Report.pdf')}/${encodeURIComponent(doc.output('bloburl', { filename: 'Leadership Report.pdf' }))}`, '_blank');
          // if (win == null) {
          //   doc.save('Leadership Report.pdf');
          // }
          this.pdf = false;
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Failed to autodownload report PDF!', error);
          this.pdf = false;
          this.$nextTick(() => {
            try {
              window.print();
            } catch (e) {
              // eslint-disable-next-line no-console
              console.error('Failed to open print dialog!', e);
            }
          });
        });
      this.pdf = false;
    },
  },
  watch: {
    async narrative(newValue) {
      if (newValue) await this.reset();
    }
  },
  async mounted() {
    this.setStats();

    await this.show();

    // uncomment to enable autodownload (but re-add soft-lock fix above if you do)
    // await this.onClickDownload();
  }
};
</script>

<style lang="scss" scoped>
@media print {
  body, body * {
    visibility: hidden !important;
    overflow: visible !important;
  }
  #report, #report * {
    visibility: visible !important;
    overflow: visible !important;
  }
  .report {
    left: 8.6% !important;
    top: 0 !important;
    width: 82.8% !important;
    overflow: visible !important;
    z-index: 10 !important;
    height: 200% !important;
    background-color: var(--primaryColor) !important;
  }

  @supports (-ms-ime-align:auto) { // a hack for detecting MS Edge... its printing is awful
    .report {
      // left: -7.5in !important;
      height: 100% !important;
      width: 100% !important;
      // margin-top: 200px !important;
    }
    .report-frame {
      position: absolute !important;
      left: -1% !important;
      top: 0 !important;
      width: 87% !important;
      height: 194% !important;
      overflow: visible !important;
      z-index: 10 !important;
      transform: translateY(-115px) !important;
      // transform: scale(1.20) translateY(150px) !important;
    }
    @page {
      margin: 20mm;
    }
  }
  @supports (-moz-appearance:none) { // a hack for detecting FF... its printing is also awful
    .report {
      top: -30% !important;
      transform: scale(0.8);
    }
  }

  .no-print, .no-print * {
    display: none !important;
  }
  .only-print, .only-print * {
    visibility: visible !important;
    height: unset !important;
  }

  .stat-info-subsection {
    font-size: 8.35pt !important;
  }
}
.only-print, .only-print * {
  visibility: hidden;
  height: 0px;
}
.only-print.pdf, .only-print.pdf * {
  visibility: visible !important;
  height: unset !important;
}
.report.pdf {
  overflow: visible !important;
  height: 230% !important;
  background-color: var(--primaryColor) !important;
  top: 0 !important;
  left: 0 !important;
}
.download-message {
  position: absolute;
  top: 50%;
  left: 25%;
  z-index: 1000;
  border-radius: 15px;
  border: 3px solid black;
  background-color: var(--primaryColor);
  color: white;
  font-size: 30pt;
  padding: 20px;
  font-weight: bold;
}

.download-button {
  position: absolute;
  bottom: 210px;
  right: 0;
  width: 350px;
  font-size: 28px;
  line-height: 55px;
  margin-right: 45px;
  z-index: 100 !important;
  transition: opacity 0.5s ease-in-out;
}

h3 {
  font-size: 1.3rem;
}
hr {
  border-top: 1px solid #e9ecef;
}
.report {
  position: absolute;
  width: 1150px;
  height: 850px;
  top: 30px;
  left: 30px;
  background-color: var(--primaryColor);
  border-radius: 5px;
  color: white;
  z-index: 1;

  color-adjust: exact;
  -webkit-print-color-adjust: exact;
}
.report-flex {
  display: flex;
  justify-content: center;
  background-color: white;
  color: black;
  box-shadow: inset 0px 0px 20px 0px rgba(219,212,219,1);
  padding: 15px;
}
.report-header {
  background-color: #343a40;
  color: white;
  width: 100%;
  text-align: left;
  font-size: 30pt;
  padding: 2px 50px;
}
.footer-logo {
  object-fit: contain;
  max-height: 30px;
  max-width: 30%;
  margin-bottom: 15px;
  z-index: 10;
}
.report-blurb {
  width: 550px;
  height: 300px;
  //padding: 10px;
  //margin: 10px 0px 10px 16px;
  font-weight: 600;
  align-content: center;
}

.slideInDown {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1); // out expo
}
.fadeOutUp {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); // in cubic
}
.narrator-notification {
  bottom: 205px;
}

/* Style the tabs */
.tabs {
  width: 100%;
  padding: 0 0 0 15px;
  height: 50px;
  display: flex;
  margin-top: -30px;
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a{
  float: right;
  cursor: pointer;
  padding: 2px 24px;
  transition: background-color 0.2s, margin-top 0.2s;
  border: 2px solid #888;
  background-color: #b2b6bc;
  color: white;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
  font-size: 22pt;
  text-align: center;
  flex: 1;
}

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #ccc;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #ceced6;
  border-bottom: none;
  color: var(--primaryColor);
  margin-top: -5px;
  margin-bottom: -2px;
  cursor: default;
}

/* Style the tab content */
.content {
  width: 100%;
  height: 450px;
}
.tabcontent {
  padding: 2px 30px 20px;
  height: 100%;
  overflow-y: auto;
  background-color: #d0d0d6;
  color: black;
  border-radius: 15px 0 0 15px;
  border: 2px solid #888;
  border-top: none;
}

.section-title {
  font-weight: bold;
  margin-top: 20px;
  padding: 0 25px;
}
.section-content {
  border-radius: 5px;
  background-color: white;
  border: 1px solid #888;
  padding: 15px 25px;
}

.report-container {
  width: 95%;
  margin: auto;
  height: 500px;
}
.tabLabel {
  font-size: 34px;
}

.stat-section {
  display: flex;
  align-items: center;
  height: fit-content;
  margin: 5px 0;
}
.max-stat-marker {
  background-color: white;
  width: 5px;
  height: 295px;
  margin: 0 10px 0 20px;
}
.stat-info-section {
  border-radius: 15px;
  background-color: white;
  border: 1px solid #888;
  width: 95%;
  height: fit-content;
  overflow: hidden !important;
}
.stat-info-title {
  background-color: #bbbbbb;
  color: black;
  padding: 0 0 0 20px;
  margin-bottom: 5px;
  text-align: left;
  width: 100%;
  border-radius: 15px 15px 0 0;
}
.stat-info-subsection {
  color: black;
  font-family: Verdana, Arial, Helvetica, sans-serif;
  font-size: 8.69pt;
  padding: 0 20px;
  margin-bottom: 2.5px;
}
@supports (-moz-appearance:none) { // a hack for detecting FF
  .stat-info-subsection {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 8.6pt !important;
    margin-bottom: 6.9pt !important;
    padding: 0 45px !important;
  }
}
.stat-info-subsection-title {
  color: var(--primaryColor) !important;
}

.v-radar {
  margin-left: 100px;
  margin-top: -40px;
  position: absolute;
  right: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/narrative/NarrativeLeadershipReport.vue